import _assign from "object-assign";
// < 1kb payload overhead when lodash/merge is > 3kb.
import deepmerge from 'deepmerge';
import warning from 'warning';
import { lightColors, darkColors, focusRing } from '@jpmuitk/style';
var dark = {
  type: 'dark',
  background: {
    contentFrame: darkColors.grey800
  },
  text: {
    primary: darkColors.white,
    contrast: darkColors.grey900
  }
};
var light = {
  type: 'light',
  background: {
    contentFrame: lightColors.white
  },
  text: {
    primary: lightColors.grey900,
    contrast: lightColors.white
  }
};
export var palettes = {
  dark: dark,
  light: light
};

var defaultColorValueMapper = function defaultColorValueMapper(_ref) {
  var value = _ref.value;
  return value;
};

var mapColor = function mapColor(activeColor, colorMapper, type) {
  return Object.keys(activeColor).reduce(function (colorMap, name) {
    colorMap[name] = colorMapper({
      name: name,
      type: type,
      value: activeColor[name]
    });
    return colorMap;
  }, {});
};
/**
 * Create a color palette
 * Currently supported palettes are (light/dark)
 *
 * @param {string} type - type of color palette (light/dark)
 * @param {function} colorMapper - callback to create color in palette
 */


export var createPalette = function createPalette() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'light';
  var colorMapper = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultColorValueMapper;
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (process.env.NODE_ENV !== 'production') {
    warning(Object.prototype.hasOwnProperty.call(palettes, type), "JPM-UI-Toolkit: the palette type `".concat(type, "` is not supported,\n      should be one of ").concat(Object.keys(palettes)));
  }

  var activeColors = type === 'light' ? lightColors : darkColors;
  return deepmerge(_assign({}, palettes[type], {
    focusRing: focusRing,
    toolkit: _assign({
      type: type
    }, mapColor(activeColors, colorMapper, type))
  }), options, // No need to clone deep
  {
    clone: false
  });
};